var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset29(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.77 123.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0ff46c;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #0b7a55;\n      }\n\n      .cls-3 {\n        fill: #3d995e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.6,
    width: 100.39,
    height: 100.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 142.18,
    cy: 31.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.05,44.83v68.64H10.53V44.84H.63v78.52h146.32V44.83h-9.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 5.59,
    cy: 31.46,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.37,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.65,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.94,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.22,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.37,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.65,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.22,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.65,
    cy: 36.45,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.37,
    cy: 36.45,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.22,
    cy: 36.45,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.94,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.94,
    cy: 36.45,
    rx: 5.59,
    ry: 5.24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset29);
export default __webpack_public_path__ + "static/media/Asset 29.15f710b26a12fd57241e96f9c7735492.svg";
export { ForwardRef as ReactComponent };